import { buildStateNode } from '../../build-state-node'

const STEP_NAME = 'reviewAndSubmit'
const EDIT_NAME = STEP_NAME + '.' + 'valid'

const stateNodeGenerator = buildStateNode({
  initial: 'empty',
  states: {
    empty: {
      on: {
        INPUT: 'valid'
      }
    },
    valid: {
      states: {
        saving: {
          on: {
            SAVE_FAIL: 'error'
          }
        },
        error: {}
      },
      on: {
        SAVE: {
          '.saving': {
            actions: []
          }
        },
        CLEAR: 'empty'
      }
    }
  }
})

export const reviewAndSubmit = {
  name: STEP_NAME,
  editState: EDIT_NAME,
  stateNodeGenerator
}
